import {
  Box,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuItem,
  MenuList,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { searchComics } from "../../services/searchApi";

const Autocomplete = ({ onSelection, suggestionsFn, readingOrderId }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [itemSelected, setItemSelected] = useState(null);

  const { isSuccess, isLoading, data, mutate } = useMutation(() => {
    return searchComics(searchTerm, readingOrderId);
  });

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm && searchTerm.length >= 3) {
        mutate();
      }
    }, 750);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, mutate]);

  const handleSelection = (item) => {
    setSearchTerm(
      `${item.order}. ${item.title} ${item.story ? `[${item.story}]` : ""}`
    );
    setItemSelected(item);
    onSelection(item);
  };

  return (
    <Box position="relative" w="full">
      <InputGroup>
        <Input
          value={searchTerm}
          autoFocus
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Backspace") {
              if (!!itemSelected) {
                setSearchTerm("");
                setItemSelected(null);
              }
            }
          }}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="E.g: The Amazing Spider-Man (1963) #1"
        />
        <InputRightElement>
          {isLoading && <Spinner size="sm" />}
        </InputRightElement>
      </InputGroup>
      {isSuccess && data?.data && !isLoading && !!searchTerm && (
        <Menu defaultIsOpen={true} autoFocus={false} autoSelect={false}>
          <MenuList
            position="absolute"
            top="10"
            maxHeight="200px"
            overflowY="auto"
            minWidth="400px"
            w="100%"
          >
            {data?.data?.map((item) => (
              <MenuItem
                key={`${item.id}-${item.order}`}
                onClick={(e) => handleSelection(item)}
                closeOnSelect
                w="100%"
              >
                {item.order}. {item.title} {item.story ? `[${item.story}]` : ""}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      )}
    </Box>
  );
};

export default Autocomplete;
